import { useEffect } from 'react';
import { websocketService } from '../services/websocket';

export function useWebSocket(sessionId, onMessage) {
  useEffect(() => {
    if (!sessionId) return;
    
    // Connect to WebSocket
    websocketService.connect();
    
    // Join session room
    websocketService.joinSession(sessionId);
    
    // Listen for messages
    const unsubscribe = websocketService.onMessage(sessionId, onMessage);
    
    // Cleanup
    return () => {
      unsubscribe();
      websocketService.leaveSession(sessionId);
    };
  }, [sessionId, onMessage]);
}
